module.exports = __webpack_public_path__ + "static/media/Clock.e49f80b3.svg";